import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Check, Clock, Sparkles, MessageCircle } from 'lucide-react';
import Card from '../components/ui/Card';
import Button from '../components/ui/Button';
import { servicePackages, addOnServices } from '../data/services';
import { BUSINESS_INFO } from '../utils/constants';

const Services = () => {
  const location = useLocation();
  const [selectedPackage, setSelectedPackage] = useState(null);

  useEffect(() => {
    if (location.state?.selectedPackage) {
      setSelectedPackage(location.state.selectedPackage);
      const element = document.getElementById(location.state.selectedPackage);
      if (element) {
        setTimeout(() => element.scrollIntoView({ behavior: 'smooth', block: 'center' }), 100);
      }
    }
  }, [location]);

  return (
    <div>
      <section className="section-blue" style={{padding: '4rem 0'}}>
        <div className="container text-center">
          <h1>Our Services</h1>
          <p style={{fontSize: '1.25rem', maxWidth: '700px', margin: '0 auto'}}>
            Professional mobile valeting packages designed to meet every need
          </p>
        </div>
      </section>

      <section className="section section-white">
        <div className="container">
          <div style={{display: 'flex', flexDirection: 'column', gap: '3rem'}}>
            {servicePackages.map((pkg) => (
              <Card 
                key={pkg.id}
                id={pkg.id}
                hover 
                style={{
                  border: selectedPackage === pkg.id ? '4px solid var(--main-blue)' : 'none'
                }}
              >
                <div className="service-detail">
                  <div className="service-detail-sidebar">
                    {pkg.popular && (
                      <span className="badge" style={{marginBottom: '0.75rem', display: 'inline-block'}}>
                        MOST POPULAR
                      </span>
                    )}
                    <h2>{pkg.name}</h2>
                    <p className="service-card-tagline">{pkg.tagline}</p>
                    <div className="service-detail-price">{pkg.price}</div>
                    <div className="service-detail-duration">
                      <Clock size={20} />
                      <span>{pkg.duration}</span>
                    </div>
                    <a href={BUSINESS_INFO.whatsappLink} target="_blank" rel="noopener noreferrer">
                      <Button variant="whatsapp" className="w-full" icon={MessageCircle}>
                        Book This Package
                      </Button>
                    </a>
                  </div>

                  <div className="service-detail-content">
                    <p style={{marginBottom: '1.5rem', lineHeight: '1.7'}}>{pkg.description}</p>
                    
                    <h3>
                      <Sparkles size={20} />
                      What's Included
                    </h3>
                    <ul className="service-detail-features">
                      {pkg.features.map((feature, idx) => (
                        <li key={idx}>
                          <Check size={20} />
                          <span>{feature}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </Card>
            ))}
          </div>
        </div>
      </section>

      <section className="section section-cream">
        <div className="container">
          <div className="section-header">
            <h2>Additional Services</h2>
            <p>Enhance your valeting package with these extra services</p>
          </div>

          <div className="grid grid-3">
            {addOnServices.map((addon) => (
              <Card key={addon.id} hover className="addon-card">
                <div className="addon-header">
                  <h3 className="addon-name">{addon.name}</h3>
                  <span className="addon-price">{addon.price}</span>
                </div>
                <p className="addon-description">{addon.description}</p>
              </Card>
            ))}
          </div>

          <div className="text-center mt-8">
            <p style={{marginBottom: '1.5rem'}}>Want to customize your service package?</p>
            <a href={BUSINESS_INFO.whatsappLink} target="_blank" rel="noopener noreferrer">
              <Button variant="primary" size="lg" icon={MessageCircle}>
                Contact Us for Custom Quote
              </Button>
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;